import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * Legacy bookmark: the personal connections surface moved twice.
 *
 * Straight to the final destination, not via `/settings/connections`. That route is itself a
 * redirect to `/settings/integrations`, so chaining them made every old bookmark cost two
 * navigations and two history entries — and the middle hop is invisible to the user, so the
 * back button appeared to do nothing.
 *
 * Both routes stay: each is somebody's bookmark, and `settings-nav-data.test.ts` asserts
 * `/settings/connections` is absent from the nav rather than absent from the router.
 */
export const Route = createFileRoute("/_authenticated/profile/connections")({
	beforeLoad: () => {
		throw redirect({ to: "/settings/integrations" });
	},
});
